import { ReadWebStoreDto } from '@goparrot/webstore-sdk';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import { WEBSTORE_QUERIES_ENUM } from '../enums';
import { webStoreFacade } from '../facades';

export const useGetWebStores = (searchFilter?: Partial<ReadWebStoreDto>, options?: UseQueryOptions<ReadWebStoreDto[]>): UseQueryResult<ReadWebStoreDto[]> => {
  return useQuery([WEBSTORE_QUERIES_ENUM.WEBSTORES, searchFilter], async () => webStoreFacade.list(searchFilter), options);
};
